import EligibleRowDesktop from './EligibleRowDesktop';
import { connect } from 'react-redux';
import { IInitialState } from 'src/store/initialState';
import { returnsActions, partsToReturnSel } from 'src/store/modules/returns';
import { IEligibleItem } from 'src/services/returns/typings';

const mapStateToProps = (state: IInitialState) => ({
  partsToReturn: partsToReturnSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  addItemToReturn: (part: IEligibleItem) => {
    dispatch(returnsActions.addPartToReturnList(part));
  },

  removeItemFromReturn: (id: number) => {
    dispatch(returnsActions.removePartFromReturnList(id));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(EligibleRowDesktop);
